import { Component, Input } from '@angular/core';
import { InternalMenuButton } from '../internal-menu-button/internal-menu-button';

@Component({
  selector: 'app-internal-toolbar',
  imports: [InternalMenuButton],
  templateUrl: './internal-toolbar.html',
  styleUrl: './internal-toolbar.scss',
})
export class InternalToolbar {
  @Input() title: string = undefined;
}
